import AdditionalInfoService from './service';
import { SaveAdditionalInfoCommentResponse, SaveAdditionalInfoCommentRequest } from './types';

export class AdditionalInfoMutations {
  public static readonly saveAdditionalInfoResponse = async (
    payload: SaveAdditionalInfoCommentRequest
  ): Promise<SaveAdditionalInfoCommentResponse> => {
    const response = await AdditionalInfoService.saveAdditionalInfoResponse(payload);
    return response;
  };
}
